import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { com.cjrodriguezproductions.divine_motors.pages.HomePage() }
        ctx.router.register("/about") { com.cjrodriguezproductions.divine_motors.pages.AboutPage() }
        ctx.router.register("/contact") {
                com.cjrodriguezproductions.divine_motors.pages.ContactPage() }
        ctx.router.register("/services") {
                com.cjrodriguezproductions.divine_motors.pages.ServicesPage() }

    }
    router.setLegacyRouteRedirectStrategy(Router.LegacyRouteRedirectStrategy.DISALLOW)
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("opposite-hover-image",
                com.cjrodriguezproductions.divine_motors.components.input_fields.OppositeHoverImageStyle)
        ctx.theme.registerStyle("input", com.cjrodriguezproductions.divine_motors.pages.InputStyle)
        ctx.theme.registerStyle(com.cjrodriguezproductions.divine_motors.components.navigation.SideMenuStyle)
        ctx.theme.registerStyle(com.cjrodriguezproductions.divine_motors.components.reasons_card.HoverColorStyle)
        ctx.theme.registerStyle(com.cjrodriguezproductions.divine_motors.components.vehicle_card.HoverImageStyle)
        ctx.theme.registerStyle(com.cjrodriguezproductions.divine_motors.pages.NavBarLinkStyle)
        ctx.theme.registerKeyframes(com.cjrodriguezproductions.divine_motors.components.navigation.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("up-down",
                com.cjrodriguezproductions.divine_motors.components.vehicle_card.upDownAnim)
        ctx.theme.registerKeyframes("zoom-in",
                com.cjrodriguezproductions.divine_motors.components.vehicle_card.zoomIn)
        ctx.theme.registerKeyframes("zoom-out",
                com.cjrodriguezproductions.divine_motors.components.vehicle_card.zoomOut)
        ctx.theme.registerKeyframes("slide",
                com.cjrodriguezproductions.divine_motors.components.vehicle_card.slideAnimation)
        com.cjrodriguezproductions.divine_motors.updateTheme(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "Divine Motors", "SM_KY" to
            "38e1aab1-0084-42ca-8324-82d1aab3d68b", "TO_EMAIL" to "ngozieuchariaoffu@gmail.com"))
    renderComposable(rootElementId = "root") {
        com.cjrodriguezproductions.divine_motors.AppEntry {
            router.renderActivePage { renderWithDeferred { it() } }
        }
    }
}
